import AboutPage from "./AboutPage";

const page = AboutPage;
export default page;
